import { useEffect } from 'react';
import { GetServerSideProps } from 'next';
import 'twin.macro';
import { useRouter } from 'next/router';

import { PopularLocality } from '@restworld/data-services';
import { useAuthContext } from '@restworld/feature-authentication';

import { IJobPositionsOfStaticOccupationProps } from '../components/home';
import { JobDomainInterestCount } from '../components/home/blocks/job-positions-per-domain';
import HomeLayout from '../components/home/home-layout';
import { HomeContextProvider, useHomeContext } from '../components/home/home.context';
import { serverFetchJpData } from '../components/home/server-side/fetch-jp-data';
import { serverBlurImages } from '../components/home/server-side/blur-images';
import { useStoreImages } from '../components/home/context/static-images';
import { getServerTranslations } from '../lib/i18n/getServerTranslations';

export type HomeStaticPropsType = {
  jobsPerDomains: JobDomainInterestCount[];
  popularLocalities: PopularLocality[];
  staticOccupations: IJobPositionsOfStaticOccupationProps['staticOccupations'];
  images: { [imgKey: string]: { blurDataURL: string; src: string } };
};
const HomePage = (props: HomeStaticPropsType) => (
  <HomeContextProvider>
    <PageContent {...props} />
  </HomeContextProvider>
);
export default HomePage;
const PageContent = (props: HomeStaticPropsType) => {
  const { setRenderPage } = useHomeContext();
  const { isAuthenticated, user } = useAuthContext();
  const { push: routerPush, query } = useRouter();
  useStoreImages(props.images);

  useEffect(() => {
    if (isAuthenticated && user?.type !== 'employer' && query?.redirected !== 'true') {
      routerPush('/cerco-lavoro');
    } else {
      setRenderPage('home-page');
    }
  }, [isAuthenticated, query?.redirected, routerPush, setRenderPage, user?.type]);

  return <HomeLayout {...props} />;
};
export const getStaticProps: GetServerSideProps<HomeStaticPropsType> = async ({ locale }) => {
  const jpData = await serverFetchJpData();
  const images = await serverBlurImages();

  const transConfig = await getServerTranslations(locale, ['common', 'home-page', 'auth-flow']);

  return {
    props: { ...jpData, ...transConfig, images },
    revalidate: 60,
  };
};
